import {createResourcesProxy, waitForCSS} from '@parcel/runtime-rsc/rsc-helpers';
let promise = Promise.all([parcelRequire.load("aarsO")]).then(() => {
let originalModule = parcelRequire("b5lTU");
let resources = <link rel="modulepreload" href={parcelRequire.resolve("aarsO")} />;
let res = createResourcesProxy(originalModule, false, resources );
  return res;
});
module.exports = promise;
